'use client';

import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { BadgeArt, rarityLabel } from './badgeIcons';
import type { Badge } from './ProfileBadgeRow';

function fmt(d: string) {
  try {
    return new Date(d).toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' });
  } catch {
    return '';
  }
}

export default function BadgeModal({
  open,
  onClose,
  badges,
}: {
  open: boolean;
  onClose: () => void;
  badges: Badge[];
}) {
  return (
    <Dialog open={open} onOpenChange={(v) => { if (!v) onClose(); }}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>All badges</DialogTitle>
        </DialogHeader>
        <ul className="mt-2 space-y-3 max-h-[60vh] overflow-y-auto pr-2">
          {badges.map((b) => {
            const rarity = rarityLabel(b.ownedPercent);
            return (
              <li key={b.slug} className="flex items-start gap-3">
                <span className="mt-0.5 inline-flex h-12 w-12 items-center justify-center rounded-full bg-muted overflow-hidden shrink-0">
                  <BadgeArt icon={b.icon} imageUrl={b.imageUrl} sizePx={48} className="h-5 w-5" />
                </span>
                <div className="min-w-0 flex-1">
                  <div className="text-sm font-medium">{b.name}</div>
                  {b.description ? (
                    <div className="text-xs text-muted-foreground mt-0.5">{b.description}</div>
                  ) : null}
                  <div className="text-xs text-muted-foreground mt-1">
                    Earned {fmt(b.earnedAt)}
                    {b.expiresAt ? ` · expires ${fmt(b.expiresAt)}` : ''}
                    {rarity ? ` · ${rarity}` : ''}
                  </div>
                </div>
              </li>
            );
          })}
        </ul>
      </DialogContent>
    </Dialog>
  );
}
